import { Clock, Whatsapp, Book1, Calendar1 } from "iconsax-react";

import {
  Article,
  Header,
  Avatar,
  Info,
  Name,
  Subject,
  Email,
  Bio,
  Schedule,
  ScheduleChip,
  Cta,
} from "./styles";

const AVATAR_PLACEHOLDER =
  "https://ui-avatars.com/api/?background=8257e5&color=fff&name=";

const DAYS_MAP: Record<string, string> = {
  "0": "Dom",
  "1": "Seg",
  "2": "Ter",
  "3": "Qua",
  "4": "Qui",
  "5": "Sex",
  "6": "Sáb",
};

function TeacherItem({ data }: any) {
  const firstSchedule = Array.isArray(data.schedule) && data.schedule[0];
  const avatarUrl = data.avatar
    ? data.avatar
    : `${AVATAR_PLACEHOLDER}${encodeURIComponent(data.name ?? "?")}`;

  return (
    <Article>
      <Header>
        <Avatar src={avatarUrl} alt={data.name} />
        <Info>
          <Name>{data.name}</Name>
          {data.subject && (
            <Subject>
              <Book1 size={13} />
              {data.subject}
            </Subject>
          )}
          {data.email && <Email>{data.email}</Email>}
        </Info>
      </Header>

      {data.bio && <Bio>{data.bio}</Bio>}

      <Schedule>
        {firstSchedule && (
          <ScheduleChip>
            <Clock size={14} />
            {firstSchedule.from} – {firstSchedule.to}
          </ScheduleChip>
        )}
        {firstSchedule?.week_day && (
          <ScheduleChip>
            <Calendar1 size={14} />
            {DAYS_MAP[firstSchedule.week_day] ?? firstSchedule.week_day}
          </ScheduleChip>
        )}
      </Schedule>

      {data.whatsapp && (
        <Cta
          href={`https://api.whatsapp.com/send?phone=${data.whatsapp}&text=Olá,%20temos%20um%20horário%20marcado.`}
          target="_blank"
          rel="noreferrer"
        >
          <Whatsapp size={17} color="#fff" />
          Entrar em contato
        </Cta>
      )}
    </Article>
  );
}

export default TeacherItem;
